import { render, staticRenderFns } from "./TwitterShare.vue?vue&type=template&id=d66a6650&"
import script from "./TwitterShare.vue?vue&type=script&lang=js&"
export * from "./TwitterShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports